var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.list, function (tag, inx) {
      return _c(
        "div",
        {
          key: inx,
          ref: "buttonRef",
          refInFor: true,
          staticClass: "item-tag",
          attrs: { title: "原名：" + tag.fieldLabel },
        },
        [
          _c("div", { staticClass: "field-name" }, [
            _c("span", [
              tag.sort == "asc"
                ? _c("i", { staticClass: "el-icon-sort-up sort-icon ml-3" })
                : _vm._e(),
              _vm._v(" "),
              tag.sort == "desc"
                ? _c("i", { staticClass: "el-icon-sort-down sort-icon ml-3" })
                : _vm._e(),
              _vm._v(" "),
              _vm._v(
                "\n        " +
                  _vm._s(tag.alias) +
                  _vm._s(
                    !_vm.isDimension
                      ? "(" + _vm.CalcMode[tag.calcMode] + ")"
                      : ""
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-error close-icon",
              on: {
                click: function ($event) {
                  return _vm.delCom(inx)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.needChangeAlias
            ? _c(
                "el-popover",
                {
                  ref: "fieldsPopoverRefs",
                  refInFor: true,
                  attrs: {
                    placement: "bottom",
                    "popper-class": "fields-popover",
                    width: 200,
                    trigger: "click",
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.chartType !== "statistic"
                        ? {
                            key: "reference",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "popover-item" },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "修改显示名",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("SvgIcon", {
                                          staticClass: "svg-icon",
                                          attrs: {
                                            "icon-class": "iconbianji3",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.visible,
                    callback: function ($$v) {
                      _vm.visible = $$v
                    },
                    expression: "visible",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "popover-div",
                      staticStyle: { padding: "10px" },
                    },
                    [
                      _c("div", { staticClass: "popover-name" }, [
                        _vm._v("修改显示名"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-100" },
                        [
                          _c("el-input", {
                            attrs: { size: "small" },
                            model: {
                              value: tag.editAlias,
                              callback: function ($$v) {
                                _vm.$set(tag, "editAlias", $$v)
                              },
                              expression: "tag.editAlias",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "w-100 mt-10",
                          staticStyle: { "text-align": "right" },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.cannerAlias(inx)
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmAlias(tag, inx)
                                },
                              },
                            },
                            [_vm._v("确认")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.needCalcMode
            ? _c(
                "el-popover",
                {
                  ref: "summaryPopoverRefs",
                  refInFor: true,
                  attrs: {
                    placement: "bottom",
                    width: 60,
                    trigger: "click",
                    "popper-class": "fields-popover",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "reference",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "popover-item" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "汇总方式",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("SvgIcon", {
                                      staticClass: "svg-icon",
                                      attrs: { "icon-class": "iconhuizong" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("div", { staticClass: "popover-name" }, [
                    _vm._v("汇总方式"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "popover-div" },
                    [
                      _vm._l(
                        _vm.modeValue(tag),
                        function (summary, summaryInx) {
                          return [
                            _c(
                              "div",
                              {
                                key: summaryInx,
                                staticClass: "popover-item",
                                class: {
                                  "is-active": tag.calcMode == summary.code,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onCalcModeChange(
                                      tag,
                                      summary.code,
                                      inx
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(summary.label) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.needSort
            ? _c(
                "el-popover",
                {
                  ref: "sortPopoverRefs",
                  refInFor: true,
                  attrs: {
                    placement: "right",
                    width: 60,
                    trigger: "click",
                    "popper-class": "fields-popover",
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.chartType !== "statistic"
                        ? {
                            key: "reference",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "popover-item" },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "排序方式",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("SvgIcon", {
                                          staticClass: "svg-icon",
                                          attrs: { "icon-class": "iconpaixu2" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("div", { staticClass: "popover-name" }, [_vm._v("排序")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "popover-div" }, [
                    _c(
                      "div",
                      {
                        staticClass: "popover-item",
                        class: { "is-active": !tag.sort },
                        on: {
                          click: function ($event) {
                            return _vm.onSort(tag, "", inx)
                          },
                        },
                      },
                      [_vm._v("默认")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "popover-item",
                        class: { "is-active": tag.sort == "asc" },
                        on: {
                          click: function ($event) {
                            return _vm.onSort(tag, "asc", inx)
                          },
                        },
                      },
                      [_vm._v("\n          升序\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "popover-item",
                        class: { "is-active": tag.sort == "desc" },
                        on: {
                          click: function ($event) {
                            return _vm.onSort(tag, "desc", inx)
                          },
                        },
                      },
                      [_vm._v("\n          降序\n        ")]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.needFormat
            ? _c(
                "el-popover",
                {
                  ref: "summaryPopoverRefs",
                  refInFor: true,
                  attrs: {
                    placement: "bottom",
                    trigger: "click",
                    "popper-class": "fields-popover",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "reference",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "popover-item" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "数据格式",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("SvgIcon", {
                                      staticClass: "svg-icon",
                                      attrs: { "icon-class": "iconshuju2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDataFormat(tag, inx)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.dialogConf.isShow,
                    callback: function ($$v) {
                      _vm.$set(_vm.dialogConf, "isShow", $$v)
                    },
                    expression: "dialogConf.isShow",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "pr-20 thousands-separator-div" },
                    [
                      _c("div", { staticClass: "popover-name" }, [
                        _vm._v("数据格式"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        { attrs: { "label-width": "120" } },
                        [
                          _c("el-form-item", { attrs: { label: "" } }, [
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [
                                _c("el-checkbox", {
                                  attrs: {
                                    disabled: _vm.needDisabledType(),
                                    label: "千分符",
                                  },
                                  model: {
                                    value:
                                      _vm.dialogConf.data.thousandsSeparator,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dialogConf.data,
                                        "thousandsSeparator",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dialogConf.data.thousandsSeparator",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [
                                _c("el-checkbox", {
                                  attrs: { label: "小数位数" },
                                  model: {
                                    value:
                                      _vm.dialogConf.data.showDecimalPlaces,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dialogConf.data,
                                        "showDecimalPlaces",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dialogConf.data.showDecimalPlaces",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.dialogConf.data.showDecimalPlaces
                                  ? _c(
                                      "span",
                                      { staticClass: "decimal-places" },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "150px" },
                                          attrs: {
                                            size: "small",
                                            min: 1,
                                            max: 4,
                                          },
                                          model: {
                                            value:
                                              _vm.dialogConf.data.decimalPlaces,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.dialogConf.data,
                                                "decimalPlaces",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "dialogConf.data.decimalPlaces",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-100" },
                              [
                                _c("el-checkbox", {
                                  attrs: {
                                    label: "数值量级",
                                    disabled: _vm.needDisabledType(),
                                  },
                                  model: {
                                    value: _vm.dialogConf.data.showNumericUnits,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.dialogConf.data,
                                        "showNumericUnits",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dialogConf.data.showNumericUnits",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.dialogConf.data.showNumericUnits
                                  ? _c(
                                      "span",
                                      { staticClass: "decimal-places" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "150px" },
                                            attrs: {
                                              filterable: "",
                                              size: "small",
                                              placeholder: "",
                                              "allow-create": "",
                                              "default-first-option": "",
                                              clearable: "",
                                            },
                                            model: {
                                              value:
                                                _vm.dialogConf.data
                                                  .numericUnits,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.dialogConf.data,
                                                  "numericUnits",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dialogConf.data.numericUnits",
                                            },
                                          },
                                          _vm._l(_vm.options, function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("el-form-item", { attrs: { label: "效果预览" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "show-preview yichu",
                                attrs: {
                                  title:
                                    _vm.getPreviewNum() +
                                    (_vm.dialogConf.data.numericUnits == "无"
                                      ? ""
                                      : _vm.dialogConf.data.numericUnits),
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.getPreviewNum())),
                                ]),
                                _vm._v(" "),
                                _vm.dialogConf.data.showNumericUnits &&
                                _vm.dialogConf.data.numericUnits != "无"
                                  ? _c("span", { staticClass: "sub" }, [
                                      _vm._v(
                                        _vm._s(_vm.dialogConf.data.numericUnits)
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: " " } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.confirmDataFormat },
                                },
                                [_vm._v("确定")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogConf.isShow = false
                                    },
                                  },
                                },
                                [_vm._v("取消")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "close-span",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.delCom(inx)
                },
              },
            },
            [_c("el-icon", [_c("ElIconCircleCloseFilled")], 1)],
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }